import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { AuftragDatumSelectionMeta } from 'app/core/batch-auftrag-api';
import { keysToTranslate } from '../../../../../../i18n/keys-to-translate';
import { CapFormRowDirective } from '../../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../../shared/form-control/form-control.component';
import { DatepickerComponent } from '../../../../../shared/datepicker/datepicker.component';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-auftrag-datum-selection',
  templateUrl: './auftrag-datum-selection.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AuftragDatumSelectionComponent),
      multi: true
    }
  ],
  imports: [
    CapFormRowDirective,
    CapFormControlComponent,
    DatepickerComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class AuftragDatumSelectionComponent implements ControlValueAccessor {
  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @Input()
  heading = 'Datum';

  @Input()
  disabled: boolean;

  model: AuftragDatumSelectionMeta;

  datumBis = 'DatumDesExports';

  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor() {
    keysToTranslate(['Datum']);
  }

  writeValue(obj: AuftragDatumSelectionMeta): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
}
